module.exports = __webpack_public_path__ + "media/newstyle/images/cta-desktop_de-5dabd712d3a61c413bb9b2f93a033c82.jpg";